'use client';
import { Button } from '@/components/commonComponents/button/button';
import { Heading } from '@/components/commonComponents/heading/heading';
import { Typography } from '../../typography';

import { CaseTile, type CaseTileProps } from './caseTile';

import styles from '../tileCarousel.module.scss';

import { LayoutContainer } from '@/components/layout-container';
import { TileCarousel } from '../tileCarousel';
import type { BaseTileCarouselProps } from '../types';

export interface CaseCarouselProps extends BaseTileCarouselProps {
  items: CaseTileProps[];
}

const headerButtonMap = {
  label: 'Alle cases',
  link: '/projecten',
};

const CaseCarousel = ({
  heading,
  items,
  introParagraph,
}: CaseCarouselProps) => (
  <div className={`${styles.carouselWrapper}`}>
    <LayoutContainer className="flex flex-col" size="large">
      <div className={styles.carouselHeaderWrapper}>
        <div className={styles.carouselHeader}>
          {heading && (
            <Heading level="h2" style="regular" tag="h2">
              {heading}
            </Heading>
          )}
          {introParagraph && (
            <Typography tag="p" variant="paragraph-reg">
              {introParagraph}
            </Typography>
          )}
        </div>
        <Button
          type="button"
          style="primary"
          icon="ArrowRight"
          href={headerButtonMap.link}
          className={styles.headerButton}
        >
          {headerButtonMap.label}
        </Button>
      </div>
      <TileCarousel>
        {items?.map((item) => (
          <CaseTile key={item?.title} {...item} />
        ))}
      </TileCarousel>
      <Button
        type="button"
        style="primary"
        icon="ArrowRight"
        href={headerButtonMap.link}
        className={styles.mobileButton}
      >
        {headerButtonMap.label}
      </Button>
    </LayoutContainer>
  </div>
);

export { CaseCarousel };
